import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import Button from '../../components/Button';
import * as images from './../../assets/images';
import { startAssessment } from '../../core/actions';
import './welcome.scss';

const Welcome: React.FC = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    function onSubmitted() {
        dispatch(startAssessment());
        navigate('/opening-questions', { replace: true });
    }

    return (
        <div className="welcome">
            <h1 className="welcome__title">Welcome to The Anxiety Center</h1>
            <h2 className="welcome__subtitle">Join us on a journey of rediscovery and find your path back to your true self. Together, we can navigate the challenges and celebrate the victories, every step of the way.</h2>
            <div className="welcome__step">
                <div className='welcome__step_container' style={{ backgroundColor: 'rgb(171, 220, 255)' }}>
                    <img className="welcome__step__image" src={images.Questionnaire} alt="Pencil Icon" />
                </div>
                <div className="welcome__step__text">step 1</div>
                <h4 className="welcome__step__title">Fill out a quick questionnaire</h4>
                <div className="welcome__step__description">This will only take two minutes.</div>
            </div>
            <div className="welcome__step">
                <div className='welcome__step_container' style={{ backgroundColor: 'rgb(172, 226, 228)' }}>
                    <img className="welcome__step__image" src={images.AssessmentResult} alt="Text Icon" />
                </div>
                <div className="welcome__step__text">step 2</div>
                <h4 className="welcome__step__title">See your results</h4>
                <div className="welcome__step__description">And get a personalized treatment recommendation.</div>
            </div>
            <div className="welcome__step">
                <div className='welcome__step_container' style={{ backgroundColor: 'rgb(255, 218, 174)' }}>
                    <img className="welcome__step__image" src={images.Treatment} alt="VideoCall Icon" />
                </div>
                <div className="welcome__step__text">step 3</div>
                <h4 className="welcome__step__title">Start treatment</h4>
                <div className="welcome__step__description">With appointments available within 24 hours.</div>
            </div>
            <Button type='primary' onPressed={onSubmitted}>
                {'GET STARTED'}
            </Button>
        </div>
    );
}

export default Welcome;
